module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00081-fs8.5919f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00081-fs8.png
// module id = 234
// module chunks = 0